import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const LogoContext = createContext();

export const LogoProvider = ({ children, initialState = { isWhite: true } }) => {
    const [logoUrl, setLogoUrl] = useState("");
    const [isWhite, setIsWhite] = useState(initialState.isWhite);
    
    // Check if process.env is available (i.e., running on the server-side)
    const BASE_URL = "https://admin.shapeshiftingmastery.ca" || window.__REACT_APP_APP_URL;

    const API_URL_PHOTO = `${BASE_URL}/api/v1/topic/photos/180`;

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await axios.get(API_URL_PHOTO);
                if (response.data.photos && response.data.photos.length > 0) {
                    setLogoUrl(response.data.photos[0].url);
                }
            } catch (error) {
                console.error("Error fetching logo:", error);
            }
        };

        // Only fetch logo on client-side
        if (typeof window !== 'undefined') {
            fetchLogo();
        }
    }, [API_URL_PHOTO]);

    return (
        <LogoContext.Provider value={{ logoUrl, isWhite, setIsWhite }}>
            {children}
        </LogoContext.Provider>
    );
};
